// import gameKit from '../../GameKit';
import { actionReactionSettings } from '../../GameKit/shared';
import DropdownItemEnum from '../components/SideBar/ActionReaction/ActionReactionDropDownItemEnum';

const defaultState = {
    openDropdownItem: DropdownItemEnum.REACT_WHEN,
    ...actionReactionSettings
};

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case 'SET_OPEN_ACTION_REACTION_DROPDOWN_ITEM': {
            return {
                ...state,
                openDropdownItem: action.payload
            };
        }
        case 'UPDATE_ACTION_REACTION_SETTINGS': {
            return {
                ...state,
                ...action.payload
            };
        }
        default: {
            return state;
        }
    }
}
